import { useEffect, useState } from "react";
import { getLtik, getLtiKeyFromStorages, postGrade } from "../api";
import { jwtDecode } from "jwt-decode";
import { COMPLETED_CONTROL_SURVEY_ROUTE } from "../App";
export const LTIK_SESSION_DATA_LS_KEY = "ltikSessionData";


export const PRE_SURVEY_URL = "https://fullerton.qualtrics.com/jfe/form/SV_3WBNjoGlNSfnEnI"
export const PRE_SURVEY_COMPLETED_URL_PARAM = "prsr";
export const POST_SURVEY_COMPLETED_URL_PARAM = "posr";

export interface LtikSessionData {
    preSurveyCompleted: boolean;
    postSurveyCompleted: boolean;
    graded: boolean;
}

export type LtikSessionDataObject = Record<string, LtikSessionData>;

export function useWithLtikSession() {
    const [submittingGrade, setSubmittingGrade] = useState(false);
    const [gradePosted, setGradePosted] = useState(false);

    useEffect(() => {
        const ltik = getLtiKeyFromStorages();
        if(!ltik) return;
        try{
        const decodedLtik = jwtDecode(ltik);
        const userId = decodedLtik["user"];
        if(!userId) return;
        const searchParams = new URL(window.location.href).searchParams;
        const preSurveyCompletedFromUrl = searchParams.get(PRE_SURVEY_COMPLETED_URL_PARAM) ? true : false;
        const postSurveyCompletedFromUrl = searchParams.get(POST_SURVEY_COMPLETED_URL_PARAM) ? true : false;
        const isAtCompletedControlSurveyRoute = window.location.pathname.includes(COMPLETED_CONTROL_SURVEY_ROUTE);
        let allLtikSessionData: LtikSessionDataObject = localStorage.getItem(LTIK_SESSION_DATA_LS_KEY) ? JSON.parse(localStorage.getItem(LTIK_SESSION_DATA_LS_KEY)) : {};

        if(!allLtikSessionData[userId]) {
            allLtikSessionData[userId] = {
                preSurveyCompleted: preSurveyCompletedFromUrl ?? false,
                postSurveyCompleted: postSurveyCompletedFromUrl ?? false,
                graded: false,
            };
        }else{
            if(preSurveyCompletedFromUrl) {
                allLtikSessionData[userId].preSurveyCompleted = true;
            }
            if(postSurveyCompletedFromUrl) {
                allLtikSessionData[userId].postSurveyCompleted = true;
            }
        }

        // if(!allLtikSessionData[userId].preSurveyCompleted) {
        //     window.location.href = PRE_SURVEY_URL
        // }

        if((postSurveyCompletedFromUrl && !allLtikSessionData[userId].graded) || isAtCompletedControlSurveyRoute) {
            setSubmittingGrade(true);
            postGrade(100).catch((error) => {
                console.error("Error posting grade:", error);
            }).finally(() => {
                allLtikSessionData[userId].graded = true;
                updateAllLtikSessionData(allLtikSessionData);
                setGradePosted(true);
                setSubmittingGrade(false);
            });
        }else{
            updateAllLtikSessionData(allLtikSessionData);
        }
        }catch(error) {
            console.error("Error decoding ltik:", error);
        }
    }, []);

    function updateAllLtikSessionData(data: LtikSessionDataObject) {
        localStorage.setItem(LTIK_SESSION_DATA_LS_KEY, JSON.stringify(data));
    }

    function getCurrentLtikSessionData(): LtikSessionData | null {
        const ltik = getLtiKeyFromStorages();
        if(!ltik) return null;
        try{
            const decodedLtik = jwtDecode(ltik);
            const userId = decodedLtik["user"];
            if(!userId) return null;
            const allLtikSessionData: LtikSessionDataObject = localStorage.getItem(LTIK_SESSION_DATA_LS_KEY) ? JSON.parse(localStorage.getItem(LTIK_SESSION_DATA_LS_KEY)) : {};
            return allLtikSessionData[userId];
        }catch(error) {
            console.error("Error decoding ltik:", error);
            return null;
        }
    }

    function getCanvasIdFromLtikToken(): string {
        try{
            const token = getLtik();
            const decodedToken = jwtDecode(token);
            return decodedToken["user"];
        }catch(error) {
            console.error("Error decoding ltik token:", error);
            return "";
        }
    }

    return{
        completedPostSurvey: getCurrentLtikSessionData()?.postSurveyCompleted ?? false,
        completedPreSurvey: getCurrentLtikSessionData()?.preSurveyCompleted ?? false,
        gradePosted,
        submittingGrade,
        isLtikSession: getCurrentLtikSessionData() ? true : false,
        canvasId: getCanvasIdFromLtikToken(),
    }
}